import React from 'react';
import Hero from './components/Hero';
import LearningFluency from './components/LearningFluency';
import Story from './components/Story';
import Vision from './components/Vision';
import WhyItMatters from './components/WhyItMatters';
import ContributionForm from './components/ContributionForm';
import Footer from './components/Footer';
import './App.css';

function App() {
  return (
    <div className="App">
      <Hero />
      <Story />
      <LearningFluency />
      <Vision />
      <WhyItMatters />
      <ContributionForm />
      <Footer />
    </div>
  );
}

export default App;